export default {
  general: {
    settings: "সেটিংস",
    show_time: "সময় প্রদর্শন দেখান",
    show_seconds: "সেকেন্ড দেখান",
    show_search: "সার্চ বার দেখান",
    show_wallpaper: "ওয়ালপেপার বাটন দেখান",
    show_bookmark: "বুকমার্ক বাটন দেখান",
    show_weather: "আবহাওয়া দেখান",
    show_top_sites: "প্রায়শই পরিদর্শন করা সাইটগুলি দেখান",
    auto_change_background: "স্বয়ংক্রিয়ভাবে ব্যাকগ্রাউন্ড পরিবর্তন করুন",
    auto_change_every: "পরিবর্তনের বিরতি",
    days: "দিন",
    hours: "ঘণ্টা",
    minutes: "মিনিট",
    interval_required: "দিন, ঘণ্টা এবং মিনিট সবগুলো ০ হতে পারে না",
    sync_enabled: "টুডু ক্লাউড সিঙ্ক",
    show_ai_chat: "এআই চ্যাট বাটন দেখান",
  },
  profile: {
    title: "প্রোফাইল",
    logout: "লগআউট",
    sign_in: "সাইন ইন",
    sign_in_desc: "পুরো অভিজ্ঞতা পেতে সাইন ইন করুন",
    avatar_updated: "প্রোফাইল ছবি সফলভাবে আপডেট করা হয়েছে",
    nickname_updated: "ডাকনাম সফলভাবে আপডেট করা হয়েছে",
    avatar_size: "অবতার ফাইলের আকার 500KB এর বেশি হওয়া উচিত নয়",
    login_required: "আপনার অবতার আপডেট করতে আপনাকে লগ ইন করতে হবে",
    login_success: "লগইন সফল",
    user_avatar: "ব্যবহারকারীর অবতার",
    edit_avatar: "অবতার সম্পাদনা করুন",
    save: "সেভ করুন",
    cancel: "বাতিল করুন"
  },
  subscription: {
    title: "সাবস্ক্রিপশন",
    check: "আমার সাবস্ক্রিপশন চেক করুন",
    upgrade: "সাবস্ক্রিপশন আপগ্রেড করুন",
    subscribe: "ট্যাবি সাবস্ক্রাইব করুন",
    expired_on: "মেয়াদ শেষ: {0}",
    expires_on: "মেয়াদ শেষ হবে: {0}",
    plans: {
      premium: "ট্যাবির সব আনলক করুন — সীমাহীন ওয়ালপেপার, কাস্টম ব্যাকগ্রাউন্ড এবং এক্সক্লুসিভ কালেকশন।",
      pro: "সীমাহীন ওয়ালপেপার, কাস্টম ব্যাকগ্রাউন্ড এবং এক্সক্লুসিভ কালেকশন আনলক করতে আপনার সাবস্ক্রিপশন আপগ্রেড করুন।",
      free: "সীমাহীন ওয়ালপেপার, কাস্টম ব্যাকগ্রাউন্ড এবং এক্সক্লুসিভ কালেকশন আনলক করতে সাবস্ক্রাইব করুন।"
    }
  },
  wallpaper: {
    title: "ওয়ালপেপার",
    upload: "কাস্টম ব্যাকগ্রাউন্ড আপলোড করুন",
    upgrade_required: "কাস্টম ব্যাকগ্রাউন্ড ফিচার আনলক করতে Pro/Premium প্ল্যানে আপগ্রেড করুন",
    images: "ছবিগুলি",
    hues: "রঙের ছটা",
    anims: "অ্যানিমেশন",
    diy: "নিজে করুন",
    get_new: "নতুন পান",
    upload_background: "ব্যাকগ্রাউন্ড আপলোড করুন",
    add: "যোগ করুন",
    remote_url: "রিমোট ইমেজ URL",
    size_tip: "ছোট ব্যাকগ্রাউন্ড ফাইল ট্যাবগুলি দ্রুত লোড করে। বেশিরভাগ ব্রাউজারে 1.5MB ফাইল সাইজ লিমিট আছে। রিমোট URL-এর কোনও সীমাবদ্ধতা নেই।",
    please_login: "প্রথমে লগইন করুন",
    click_to_upload: "আপলোড করতে ক্লিক করুন",
    video_gif_image: "ভিডিও, GIF বা ছবি",
    background: "ব্যাকগ্রাউন্ড",
    or_enter_remote_background_url: "অথবা রিমোট ব্যাকগ্রাউন্ড URL লিখুন",
    remote_url_placeholder: "https://example.com/image.jpg",
    custom_background_removed: "কাস্টম ব্যাকগ্রাউন্ড সরানো হয়েছে",
    failed_to_load_background: "ব্যাকগ্রাউন্ড লোড করতে ব্যর্থ",
    using_default: "পরিবর্তে ডিফল্ট ব্যাকগ্রাউন্ড ব্যবহার করা হচ্ছে",
    insufficient_storage: "অপর্যাপ্ত স্টোরেজ",
    upload_failed: "আপলোড ব্যর্থ হয়েছে",
    success: "সফল",
    remote_background_added: "রিমোট ব্যাকগ্রাউন্ড যোগ করা হয়েছে",
    detecting_media_type: "মিডিয়া টাইপ শনাক্ত করা হচ্ছে...",
    invalid_media_type: "অপরিচিত মিডিয়া টাইপ",
    video_load_failed: "ভিডিও লোড করা যাচ্ছে না, URL সঠিক কিনা চেক করুন"
  },
  rewards: {
    title: "পুরস্কার",
    invite_friends: "বন্ধুদের আমন্ত্রণ করুন",
    get_access: "বন্ধুদের আমন্ত্রণ জানিয়ে Pro-তে ডিসকাউন্ট আনলক করুন",
    total_invites: "মোট আমন্ত্রণ",
    your_discount: "আপনার ডিসকাউন্ট",
    no_pro_yet: "এখনও নেই",
    copy_link: "আমন্ত্রণ লিঙ্ক কপি করুন",
    copied: "আমন্ত্রণ লিঙ্ক কপি করা হয়েছে!",
    copy_failed: "লিঙ্ক কপি করতে ব্যর্থ",
    invite_description: "আপনার লিঙ্ক দিয়ে বন্ধু নিবন্ধন করান",
    receive_credits: "আপনি পাবেন: 1 আমন্ত্রণ → 5% ছাড়, 2 → 8% ছাড়, 3 → 15% ছাড়, 4+ → 20% ছাড় · প্রতিটি বন্ধু 5% ছাড় পাবে"
  },
  paywall: {
    title: "Tabby Pro",
    pro_active: "Pro চালু আছে",
    expires: "মেয়াদ শেষ",
    free_plan: "ফ্রি প্ল্যান",
    tagline: "সম্পূর্ণ চ্যাট কোটা, ক্লাউড টোডো সিঙ্ক এবং সব ওয়ালপেপার ফিচার এই এক্সটেনশনে আনলক করুন।",
    monthly: "মাসিক",
    yearly: "বার্ষিক",
    month_period: "/মাস",
    year_period: "/বছর",
    billed_monthly: "মাসিক বিল · যেকোনো সময় বাতিল",
    billed_yearly: "বার্ষিক বিল",
    checkout_usd: "চেকআউট",
    save_yearly: "মাসিকের তুলনায় 17% সাশ্রয়",
    best_value: "সেরা মূল্য",
    referral_price: "রেফারেল মূল্য",
    save: "সাশ্রয়",
    subscribe_now: "এখনই সাবস্ক্রাইব করুন",
    current_plan: "বর্তমান প্ল্যান",
    processing: "প্রসেস হচ্ছে",
    waiting_title: "পেমেন্টের অপেক্ষায়",
    waiting_desc: "নতুন খোলা উইন্ডোতে পেমেন্ট সম্পন্ন করুন।",
    payment_completed: "পেমেন্ট সম্পন্ন",
    having_issues: "সমস্যা হচ্ছে",
    invite_save: "বন্ধুদের আমন্ত্রণ জানিয়ে Pro-তে সাশ্রয় করুন",
    sign_in_first: "আগে লগ ইন করুন",
    checkout_failed: "পেমেন্ট সেশন তৈরি করা যায়নি",
    payment_failed: "পেমেন্ট ব্যর্থ",
    payment_wrong: "কিছু ভুল হয়েছে। আবার চেষ্টা করুন।",
    success_msg: "অভিনন্দন! পেমেন্ট সফলভাবে সম্পন্ন হয়েছে",
    not_paid_msg: "পেমেন্ট এখনও সম্পন্ন হয়নি। উইন্ডোতে পেমেন্ট সম্পন্ন করুন বা আবার চেষ্টা করুন।",
    verify_failed: "পেমেন্ট স্ট্যাটাস যাচাই করা যায়নি। আবার চেষ্টা করুন বা সাপোর্টে যোগাযোগ করুন।",
    contact_email: "ইমেইল যোগাযোগ: hi@tabbyio.com"
  },
  about: {
    title: "সম্পর্কে",
    version: "সংস্করণ: 1.3.11",
    contact: "আমাদের সাথে যোগাযোগ করুন:",
    privacy_policy: "গোপনীয়তা নীতি",
    terms_of_service: "পরিষেবার শর্তাবলী"
  },
  tabs: {
    general: "পছন্দ",
    profile: "প্রোফাইল",
    wallpaper: "ওয়ালপেপার",
    rewards: "পুরস্কার",
    about: "সম্পর্কে"
  },
  language: {
    title: "ভাষা",
    en: "English",
    zh: "中文",
    de: "Deutsch",
    fr: "Français",
    pt: "Português",
    ru: "Русский",
    bn: "বাংলা",
    ja: "日本語",
    es: "Español"
  },
  buttons: {
    bookmark: "বুকমার্ক",
    next_background: "পরবর্তী ব্যাকগ্রাউন্ড",
    ai_chat: "এআই চ্যাট",
    search_placeholder: "সার্চ করুন বা এআই চ্যাটের জন্য Ctrl + Enter প্রেস করুন...",
    attach: "ফাইল সংযুক্ত করুন",
  },
  top_sites: {
    title: "প্রায়শই পরিদর্শন করা সাইটগুলি",
    error: "প্রায়শই পরিদর্শন করা সাইটগুলি লোড করা যায়নি",
    empty: "কোন প্রায়শই পরিদর্শন করা সাইট পাওয়া যায়নি"
  },
  greetings: {
    morning: "শুভ সকাল",
    afternoon: "শুভ দুপুর",
    evening: "শুভ সন্ধ্যা",
    morning_message: "নতুন দিন শুরু হয়েছে, আমি আপনাকে কীভাবে সাহায্য করতে পারি?",
    afternoon_message: "দুপুরের সময়, কোনো প্রশ্ন জিজ্ঞেস করতে চান?",
    evening_message: "সন্ধ্যার সময়, আপনার সাথে কথা বলি!"
  },
  intro: {
    your_portal: "আপনার পোর্টাল",
    for: "এর জন্য",
    productivity: "উৎপাদনশীলতা।",
    inspiration: "অনুপ্রেরণা।",
    photography: "ফটোগ্রাফি।",
    description: "যেখানে প্রতিটি নতুন ট্যাব একটি প্রবেশদ্বার হয়ে ওঠে",
    description_continued: "সৌন্দর্য, উৎপাদনশীলতা এবং তার বাইরেও।",
    add_to_chrome: "ক্রোমে যোগ করুন",
    free: "ফ্রি",
    try_now: "এখনই চেষ্টা করুন",
    screenshot: "স্ক্রিনশট"
  }
}

